export default "__VITE_ASSET__BGv70Y6U__"